import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=6c2f028d&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c2f028d')) {
      api.createRecord('6c2f028d', component.options)
    } else {
      api.reload('6c2f028d', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=6c2f028d&", function () {
      api.rerender('6c2f028d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TN2Ec1A9uoO2/JS/pricehelp.vue"
export default component.exports